import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPAProductsStart,
  getPAProductsSuccess,
  getPAProductsFailure,
} from "../reducers/getPAProductsReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getPAProducts = createAsyncThunk(
  "getPAProducts",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getPAProductsStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/PA/GetPAProduct`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getPAProductsSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getPAProductsFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
